var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isEmpty, isNil } from 'lodash-es';
import { SdsInputBase } from '../input/_sds-input-base';
import { appendStylesToTheGlobalStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-multilingual-global.lit.scss';
import { MultilingualContainer } from './container/multilingual-container';
import { MultilingualContainerPosition } from './container/multilingual-container-position';
let SdsInputMultilingualBase = (() => {
    var _a, _SdsInputMultilingualBase_value_accessor_storage, _SdsInputMultilingualBase_showCount_accessor_storage, _SdsInputMultilingualBase_maxLength_accessor_storage, _SdsInputMultilingualBase_placeholder_accessor_storage, _SdsInputMultilingualBase_focused_accessor_storage, _SdsInputMultilingualBase_disabled_accessor_storage, _SdsInputMultilingualBase_hint_accessor_storage, _SdsInputMultilingualBase_invalid_accessor_storage, _SdsInputMultilingualBase_currentLanguage_accessor_storage, _SdsInputMultilingualBase_autoResize_accessor_storage, _SdsInputMultilingualBase_rows_accessor_storage, _SdsInputMultilingualBase_rtl_accessor_storage, _SdsInputMultilingualBase__input_accessor_storage;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _showCount_decorators;
    let _showCount_initializers = [];
    let _showCount_extraInitializers = [];
    let _maxLength_decorators;
    let _maxLength_initializers = [];
    let _maxLength_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _autoResize_decorators;
    let _autoResize_initializers = [];
    let _autoResize_extraInitializers = [];
    let _rows_decorators;
    let _rows_initializers = [];
    let _rows_extraInitializers = [];
    let _set_maxRows_decorators;
    let _rtl_decorators;
    let _rtl_initializers = [];
    let _rtl_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    return _a = class SdsInputMultilingualBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsInputMultilingualBase_value_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _value_initializers, {})));
                _SdsInputMultilingualBase_showCount_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _showCount_initializers, void 0)));
                _SdsInputMultilingualBase_maxLength_accessor_storage.set(this, (__runInitializers(this, _showCount_extraInitializers), __runInitializers(this, _maxLength_initializers, 1000)));
                _SdsInputMultilingualBase_placeholder_accessor_storage.set(this, (__runInitializers(this, _maxLength_extraInitializers), __runInitializers(this, _placeholder_initializers, '')));
                _SdsInputMultilingualBase_focused_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _focused_initializers, false)));
                _SdsInputMultilingualBase_disabled_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsInputMultilingualBase_hint_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _hint_initializers, '')));
                _SdsInputMultilingualBase_invalid_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
                _SdsInputMultilingualBase_currentLanguage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _currentLanguage_initializers, void 0)));
                _SdsInputMultilingualBase_autoResize_accessor_storage.set(this, (__runInitializers(this, _currentLanguage_extraInitializers), __runInitializers(this, _autoResize_initializers, false)));
                _SdsInputMultilingualBase_rows_accessor_storage.set(this, (__runInitializers(this, _autoResize_extraInitializers), __runInitializers(this, _rows_initializers, void 0)));
                this._maxRows = (__runInitializers(this, _rows_extraInitializers), 8);
                _SdsInputMultilingualBase_rtl_accessor_storage.set(this, __runInitializers(this, _rtl_initializers, void 0));
                this.handleFocus = (__runInitializers(this, _rtl_extraInitializers), () => {
                    this.focused = true;
                    this.openMultilingualInput();
                });
                this._stylesGlobal = stylesGlobal;
                _SdsInputMultilingualBase__input_accessor_storage.set(this, __runInitializers(this, __input_initializers, void 0));
                this._multilingualContainer = __runInitializers(this, __input_extraInitializers);
                this.updateValue = () => {
                    this.requestUpdate('value');
                    this.dispatchMultilingualInputEvent();
                };
                this.documentClickHandler = (e) => {
                    if (e.target instanceof HTMLElement) {
                        if (!this._multilingualContainer.getContainer().contains(e.target) &&
                            e.target !== this &&
                            e.target !== this._input) {
                            this.closeMultilingualInput();
                        }
                    }
                };
                this.doneClickHandler = () => this.closeMultilingualInput();
                this.handleInputEvent = (e) => {
                    this.value[this.getCurrentLanguage()] = e.detail.value;
                    this.updateValue();
                };
                this.handleInputChangeEvent = (e) => {
                    this.value[this.getCurrentLanguage()] = e.detail.value;
                    this.dispatchMultilingualClosedEvent();
                    this.dispatchMultilingualChangedEvent();
                };
            }
            /**
             * Represents the multilingual input value.
             * This attribute accepts an object where each key corresponds to a language,
             * and each value is the text in that language.
             *
             * @type {Languages} - The multilingual input value.
             */
            get value() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_value_accessor_storage, value, "f"); }
            /**
             * Indicates if the character count is displayed.
             * This attribute, when true, shows the number of characters typed.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} show-count - If true, shows the character count.
             */
            get showCount() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_showCount_accessor_storage, "f"); }
            set showCount(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_showCount_accessor_storage, value, "f"); }
            /**
             * Sets the maximum number of characters allowed in the input.
             * This attribute enforces a character limit to prevent excessive text entry.
             *
             * Defaults to `1000`.
             *
             * @attr {number} max-length - The maximum character limit.
             */
            get maxLength() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_maxLength_accessor_storage, "f"); }
            set maxLength(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_maxLength_accessor_storage, value, "f"); }
            /**
             * Placeholder text shown when the input is empty.
             * This attribute provides a visual hint to users about the expected content.
             *
             * Defaults to an empty string.
             *
             * @attr {string} placeholder - The input placeholder text.
             */
            get placeholder() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_placeholder_accessor_storage, "f"); }
            set placeholder(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_placeholder_accessor_storage, value, "f"); }
            /**
             * Indicates if the input is focused.
             * This attribute reflects the focus state of the input.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} focused - If true, the input is focused.
             */
            get focused() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_focused_accessor_storage, "f"); }
            set focused(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_focused_accessor_storage, value, "f"); }
            /**
             * Indicates if the input is disabled.
             * This attribute, when true, prevents user interaction with the input.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} disabled - If true, the input is disabled.
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_disabled_accessor_storage, value, "f"); }
            /**
             * Provides a hint or additional information to assist users.
             * This attribute can display supplementary guidance relevant to the input.
             *
             * Defaults to an empty string.
             *
             * @attr {string} hint - The hint text.
             */
            get hint() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_hint_accessor_storage, "f"); }
            set hint(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_hint_accessor_storage, value, "f"); }
            /**
             * Indicates if this multilingual input is invalid.
             * This attribute reflects the validation status of the input and displays
             * an error message if the input does not meet the specified criteria.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} invalid - If true, the input is invalid.
             */
            get invalid() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_invalid_accessor_storage, "f"); }
            set invalid(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_invalid_accessor_storage, value, "f"); }
            /**
             * The currently selected language for input.
             * This attribute specifies the language which is displayed in a closed state.
             *
             * Defaults to an empty string.
             *
             * @attr {string} current-language - The selected language.
             */
            get currentLanguage() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_currentLanguage_accessor_storage, "f"); }
            set currentLanguage(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_currentLanguage_accessor_storage, value, "f"); }
            get autoResize() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_autoResize_accessor_storage, "f"); }
            set autoResize(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_autoResize_accessor_storage, value, "f"); }
            get rows() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_rows_accessor_storage, "f"); }
            set rows(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_rows_accessor_storage, value, "f"); }
            set maxRows(value) {
                this._maxRows = value > 8 ? 8 : value;
            }
            get maxRows() {
                return this._maxRows;
            }
            /**
             * Languages to display in right-to-left (RTL) mode.
             * This attribute accepts a comma-separated list of language that should be displayed in RTL.
             *
             * Defaults to an empty array.
             *
             * @attr {Array<string>} rtl - List of RTL languages.
             */
            get rtl() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase_rtl_accessor_storage, "f"); }
            set rtl(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase_rtl_accessor_storage, value, "f"); }
            get _input() { return __classPrivateFieldGet(this, _SdsInputMultilingualBase__input_accessor_storage, "f"); }
            set _input(value) { __classPrivateFieldSet(this, _SdsInputMultilingualBase__input_accessor_storage, value, "f"); }
            async updated() {
                var _b;
                await this.updateComplete;
                const validLanguages = Object.keys(this.value);
                const invalidValue = validLanguages.length === 0;
                if (invalidValue) {
                    console.warn('sds-input-multilingual: "value" property is missing or empty. Rendering with default state.');
                }
                if (this.currentLanguage &&
                    !invalidValue &&
                    !validLanguages.includes(this.currentLanguage)) {
                    console.warn(`sds-input-multilingual: "currentLanguage" (${this.currentLanguage}) does not match any keys in "value".`);
                }
                if (!isNil(this._input) && !invalidValue) {
                    if ((_b = this.rtl) === null || _b === void 0 ? void 0 : _b.includes(this.getCurrentLanguage())) {
                        this._input.setAttribute('dir', 'rtl');
                    }
                    else {
                        this._input.removeAttribute('dir');
                    }
                }
            }
            async firstUpdated() {
                var _b, _c;
                appendStylesToTheGlobalStyleRoot('sds-multilingual', this._stylesGlobal.cssText);
                await this.updateComplete;
                if (Object.keys(this.value).length !== 0 && ((_b = this.rtl) === null || _b === void 0 ? void 0 : _b.includes(this.getCurrentLanguage()))) {
                    this._input.setAttribute('dir', 'rtl');
                }
                if (!this.isMultiLanguageValue()) {
                    (_c = this._input) === null || _c === void 0 ? void 0 : _c.addEventListener(SdsInputBase.TEXT_CLEARED, this.handleInputEvent);
                }
                this.initComponent();
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                if (this._multilingualContainer) {
                    this.closeMultilingualInput();
                }
            }
            willUpdate(_changedProperties) {
                var _b;
                if (_changedProperties.has('currentLanguage') ||
                    _changedProperties.has('rtl') ||
                    (_changedProperties.has('value') && !isEmpty(this.value))) {
                    if (Object.keys(this.value).length !== 0 &&
                        this._input &&
                        ((_b = this.rtl) === null || _b === void 0 ? void 0 : _b.includes(this.getCurrentLanguage()))) {
                        this._input.setAttribute('dir', 'rtl');
                    }
                    this.initComponent();
                }
            }
            getCurrentLanguage() {
                return this.currentLanguage
                    ? this.currentLanguage
                    : this.value
                        ? Object.keys(this.value)[0]
                        : '';
            }
            getCurrentLanguageValue() {
                return this.value ? this.value[this.getCurrentLanguage()] : '';
            }
            initComponent() {
                if (!this.focused) {
                    if (this.isMultiLanguageValue()) {
                        this.createMultilingualContainer();
                        this._multilingualContainer.prepareMultilingualInput();
                    }
                    else if (this._input) {
                        this._input.addEventListener(SdsInputBase.INPUT_EVENT, this.handleInputEvent);
                        this._input.addEventListener(SdsInputBase.TEXT_CLEARED, this.handleInputEvent);
                        this._input.addEventListener(SdsInputBase.CHANGE_EVENT, this.handleInputChangeEvent);
                    }
                }
            }
            isMultiLanguageValue() {
                return Object.keys(this.value).length > 1;
            }
            removeInputEventListeners() {
                if (!this.isMultiLanguageValue()) {
                    this._input.removeEventListener(SdsInputBase.INPUT_EVENT, this.handleInputEvent);
                    this._input.removeEventListener(SdsInputBase.TEXT_CLEARED, this.handleInputEvent);
                    this._input.removeEventListener(SdsInputBase.CHANGE_EVENT, this.handleInputChangeEvent);
                }
            }
            openMultilingualInput() {
                if (this._multilingualContainer) {
                    this.appendContainerToDocument();
                    this.addDocumentClickHandler();
                    this._multilingualContainerPosition.initContainerPosition(this._input);
                    setTimeout(() => this.focusFirstInput());
                }
            }
            appendContainerToDocument() {
                this._multilingualContainer.getContainer().classList.add('sds-multilingual-container');
                this._multilingualContainer.getContainer().setAttribute('id', 'sds-multilingual-container');
                document.body.append(this._multilingualContainer.getContainer());
            }
            addDocumentClickHandler() {
                document.addEventListener('mouseup', this.documentClickHandler);
            }
            focusFirstInput() {
                if (this.focused) {
                    this._multilingualContainer.focusFirstInput();
                }
            }
            closeMultilingualInput() {
                if (this.focused) {
                    this.focused = false;
                    this._multilingualContainerPosition.stopContainerPosition();
                    this._input.handleResize();
                    this.removeDocumentClickHandler();
                    this.removeContainerFromDocument();
                    this.removeInputEventListeners();
                    this.dispatchMultilingualChangedEvent();
                    this.dispatchMultilingualClosedEvent();
                }
            }
            removeContainerFromDocument() {
                this._multilingualContainer.getContainer().remove();
            }
            removeDocumentClickHandler() {
                document.removeEventListener('mouseup', this.documentClickHandler);
            }
            dispatchMultilingualInputEvent() {
                this.dispatchEvent(new CustomEvent(_a.MULTILINGUAL_INPUT_EVENT, {
                    detail: {
                        value: this.value,
                    },
                }));
            }
            dispatchMultilingualChangedEvent() {
                this.dispatchEvent(new CustomEvent(_a.MULTILINGUAL_CHANGED_EVENT, {
                    detail: {
                        value: this.value,
                    },
                }));
            }
            dispatchMultilingualClosedEvent() {
                this.dispatchEvent(new CustomEvent(_a.MULTILINGUAL_CLOSED_EVENT));
            }
            createMultilingualContainer() {
                this._multilingualContainer = new MultilingualContainer(this.value, this.getCurrentLanguage(), this.createInputElement, this.getContentClass, this.updateValue, this.doneClickHandler, this.invalid, this.maxLength, this.showCount, this.autoResize, this.rows, this.maxRows, this.parentElement ? this.parentElement['label'] : undefined, this.parentElement ? this.parentElement['required'] : undefined, this.rtl);
                this._multilingualContainerPosition = new MultilingualContainerPosition(this._multilingualContainer);
            }
        },
        _SdsInputMultilingualBase_value_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_showCount_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_maxLength_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_placeholder_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_focused_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_disabled_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_hint_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_invalid_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_currentLanguage_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_autoResize_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_rows_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase_rtl_accessor_storage = new WeakMap(),
        _SdsInputMultilingualBase__input_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({
                    type: Object,
                    attribute: false,
                })];
            _showCount_decorators = [property({ attribute: 'show-count', type: Boolean })];
            _maxLength_decorators = [property({ attribute: 'maxlength', type: Number })];
            _placeholder_decorators = [property({ type: String })];
            _focused_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            _hint_decorators = [property({ type: String })];
            _invalid_decorators = [property({ type: Boolean })];
            _currentLanguage_decorators = [property({ type: String, attribute: 'current-language' })];
            _autoResize_decorators = [property({ type: Boolean, attribute: 'auto-resize' })];
            _rows_decorators = [property({ type: Number, reflect: true })];
            _set_maxRows_decorators = [property({ type: Number, attribute: 'max-rows', reflect: true })];
            _rtl_decorators = [property({
                    type: String,
                    converter: value => {
                        if (value) {
                            return value.split(',').map(s => s.trim());
                        }
                        return new Array();
                    },
                })];
            __input_decorators = [query('#input')];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _showCount_decorators, { kind: "accessor", name: "showCount", static: false, private: false, access: { has: obj => "showCount" in obj, get: obj => obj.showCount, set: (obj, value) => { obj.showCount = value; } }, metadata: _metadata }, _showCount_initializers, _showCount_extraInitializers);
            __esDecorate(_a, null, _maxLength_decorators, { kind: "accessor", name: "maxLength", static: false, private: false, access: { has: obj => "maxLength" in obj, get: obj => obj.maxLength, set: (obj, value) => { obj.maxLength = value; } }, metadata: _metadata }, _maxLength_initializers, _maxLength_extraInitializers);
            __esDecorate(_a, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
            __esDecorate(_a, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
            __esDecorate(_a, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
            __esDecorate(_a, null, _currentLanguage_decorators, { kind: "accessor", name: "currentLanguage", static: false, private: false, access: { has: obj => "currentLanguage" in obj, get: obj => obj.currentLanguage, set: (obj, value) => { obj.currentLanguage = value; } }, metadata: _metadata }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
            __esDecorate(_a, null, _autoResize_decorators, { kind: "accessor", name: "autoResize", static: false, private: false, access: { has: obj => "autoResize" in obj, get: obj => obj.autoResize, set: (obj, value) => { obj.autoResize = value; } }, metadata: _metadata }, _autoResize_initializers, _autoResize_extraInitializers);
            __esDecorate(_a, null, _rows_decorators, { kind: "accessor", name: "rows", static: false, private: false, access: { has: obj => "rows" in obj, get: obj => obj.rows, set: (obj, value) => { obj.rows = value; } }, metadata: _metadata }, _rows_initializers, _rows_extraInitializers);
            __esDecorate(_a, null, _set_maxRows_decorators, { kind: "setter", name: "maxRows", static: false, private: false, access: { has: obj => "maxRows" in obj, set: (obj, value) => { obj.maxRows = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _rtl_decorators, { kind: "accessor", name: "rtl", static: false, private: false, access: { has: obj => "rtl" in obj, get: obj => obj.rtl, set: (obj, value) => { obj.rtl = value; } }, metadata: _metadata }, _rtl_initializers, _rtl_extraInitializers);
            __esDecorate(_a, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.MULTILINGUAL_INPUT_EVENT = 'sds.multilingual.input',
        _a.MULTILINGUAL_CLOSED_EVENT = 'sds.multilingual.closed',
        _a.MULTILINGUAL_CHANGED_EVENT = 'sds.multilingual.changed',
        _a;
})();
export { SdsInputMultilingualBase };
